var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jz-container',{staticClass:"terratalk-live-lobby"},[_c('jz-container',{staticClass:"live-details"},[_c('terratalk-live-session-active',{attrs:{"session-details":_vm.activeSessionDetails}}),_c('limited-mode-details')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }